export const BitbucketLogoBrand = () => (
  <svg
    width="233"
    height="48"
    viewBox="0 0 233 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M49.3629 8.51416H62.0139C68.1789 8.51416 71.1689 11.5502 71.1689 16.4272C71.1689 20.0612 69.5129 22.3162 66.1079 23.1442C70.5699 23.8792 72.7779 26.3182 72.7779 30.5962C72.7779 35.4272 69.5119 38.7402 62.7499 38.7402H49.3619V8.51416H49.3629ZM53.5039 12.4702V21.4882H61.4629C65.3729 21.4882 66.9839 19.6932 66.9839 16.7962C66.9839 13.8522 65.2359 12.4712 61.4629 12.4712H53.5039V12.4702ZM53.5039 25.1672V34.5992H62.8889C66.8449 34.5992 68.6399 33.1732 68.6399 30.1362C68.6399 26.9162 66.9379 25.1672 62.7969 25.1672H53.5039Z"
      fill="#172B4D"
    />
    <path
      d="M79.539 6.9043C81.149 6.9043 82.299 7.9163 82.299 9.6653C82.299 11.4143 81.15 12.4253 79.539 12.4253C77.928 12.4253 76.778 11.4133 76.778 9.6653C76.778 7.9173 77.928 6.9043 79.539 6.9043ZM77.515 15.7373H81.472V38.7403H77.515V15.7373Z"
      fill="#172B4D"
    />
    <path
      d="M96.56 35.0139C97.48 35.0139 98.354 34.8289 99.044 34.6919V38.5099C98.354 38.6949 97.571 38.8779 96.375 38.8779C91.453 38.8779 89.061 35.9799 89.061 31.7009V19.4179H85.334V15.7369H89.061V10.8599H92.925V15.7369H99.044V19.4179H92.925V31.6089C92.925 33.6329 94.121 35.0129 96.56 35.0129V35.0139Z"
      fill="#172B4D"
    />
    <path
      d="M108.06 34.6911V38.7401H104.103V6.12207H108.06V19.8781C109.532 16.8421 112.292 15.2771 115.834 15.2771C121.953 15.2771 125.035 20.4751 125.035 27.2381C125.035 33.7251 121.814 39.2001 115.374 39.2001C112.016 39.2001 109.439 37.6811 108.06 34.6911ZM114.776 18.9581C111.234 18.9581 108.06 21.2121 108.06 26.3181V28.1591C108.06 33.2651 110.957 35.5191 114.316 35.5191C118.779 35.5191 121.079 32.5751 121.079 27.2381C121.079 21.7171 118.871 18.9581 114.776 18.9581Z"
      fill="#172B4D"
    />
    <path
      d="M129.172 15.7373H133.128V29.6313C133.128 33.7723 134.784 35.6113 138.557 35.6113C142.238 35.6113 144.768 33.1733 144.768 28.5263V15.7373H148.725V38.7403H144.768V34.9683C143.296 37.6823 140.581 39.2003 137.499 39.2003C132.208 39.2003 129.172 35.5653 129.172 29.2173V15.7373Z"
      fill="#172B4D"
    />
    <path
      d="M170.941 38.1409C169.56 38.8769 167.444 39.1999 165.328 39.1999C157.14 39.1999 153.321 34.2309 153.321 27.1919C153.321 20.2459 157.139 15.2769 165.328 15.2769C167.398 15.2769 169.009 15.5529 170.803 16.3809V20.0609C169.331 19.3719 167.767 18.9569 165.605 18.9569C159.625 18.9569 157.186 22.7289 157.186 27.1909C157.186 31.6529 159.67 35.4259 165.697 35.4259C168.044 35.4259 169.515 35.1039 170.942 34.5979V38.1399L170.941 38.1409Z"
      fill="#172B4D"
    />
    <path
      d="M175.447 38.7401V6.12207H179.404V26.5031L189.295 15.7371H194.447L183.636 27.0541L194.907 38.7401H189.525L179.404 27.9741V38.7401H175.447Z"
      fill="#172B4D"
    />
    <path
      d="M208.016 39.1999C199.413 39.1999 195.641 34.2309 195.641 27.1919C195.641 20.2459 199.505 15.2769 206.498 15.2769C213.582 15.2769 216.435 20.1999 216.435 27.1919V28.9869H199.643C200.196 32.8969 202.726 35.4269 208.155 35.4269C210.823 35.4269 213.077 34.9209 215.147 34.1849V37.8199C213.261 38.8319 210.363 39.1999 208.016 39.1999ZM199.597 25.5819H212.433C212.203 21.3039 210.271 18.8659 206.314 18.8659C202.127 18.8659 200.011 21.5799 199.597 25.5819Z"
      fill="#172B4D"
    />
    <path
      d="M230.233 35.0139C231.153 35.0139 232.027 34.8289 232.717 34.6919V38.5099C232.027 38.6949 231.244 38.8779 230.048 38.8779C225.126 38.8779 222.734 35.9799 222.734 31.7009V19.4179H219.007V15.7369H222.734V10.8599H226.598V15.7369H232.717V19.4179H226.598V31.6089C226.598 33.6329 227.794 35.0129 230.233 35.0129V35.0139Z"
      fill="#172B4D"
    />
    <path
      d="M1.04594 9.397C0.400943 9.397 -0.0900567 9.975 0.0139433 10.612L4.43794 37.552C4.54994 38.234 5.13894 38.734 5.82894 38.74L27.1199 38.736C27.6329 38.736 28.0709 38.364 28.1529 37.858L32.6019 10.617C32.7059 9.981 32.2149 9.403 31.5699 9.403L1.04494 9.396L1.04594 9.397ZM19.7349 28.869H12.9139L11.0979 19.259H21.3799L19.7349 28.869Z"
      fill="#1D7AFC"
    />
    <path
      d="M31.191 19.2588H21.38L19.735 28.8688H12.914L4.91296 38.3958C4.91296 38.3958 5.27196 38.7398 5.82896 38.7398L27.121 38.7358C27.633 38.7358 28.07 38.3638 28.152 37.8588L31.19 19.2588H31.191Z"
      fill="url(#paint0_linear_818_492)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_818_492"
        x1="33.46"
        y1="21.9488"
        x2="17.245"
        y2="34.6058"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.176" stopColor="#0055CC" />
        <stop offset="1" stopColor="#1D7AFC" />
      </linearGradient>
    </defs>
  </svg>
);
